import classNames from "classnames";
import { ErrorIcon, TryAgainIcon, ReportBug, AssistantErrorIcon } from "../icons/ErrorIcon";
import { useSelector } from "redux/hooks";
import { FormattedMessage } from "react-intl";
import styles from "./ErrorMessage.module.scss";
import { IChatModel, IMessage } from "redux/actions";

interface IProp {
    message?: IMessage;
    messageIndex?: number;
    onRegenerate?: (messageIndex: number, chatModal: IChatModel, regenerateModel?: boolean) => void;
    assistanceError?:boolean;
}

export const ErrorMessageDisplay = ({ message, messageIndex, onRegenerate, assistanceError } : IProp) => {

    const { theme } = useSelector((state) => state.authReducer);

    const handleReportBug = () => {
        window.open("https://deftgpt.canny.io/bugs", "_blank");
    };

    return(
        <div className={classNames(styles.errorContainer, {
            [styles.light]: theme === "light",
            [styles.dark]: theme === "dark",
          })}>
            <div className = "flex items-center gap-2">
           {assistanceError ? <AssistantErrorIcon /> : <ErrorIcon /> }
            <span className={`font-inter ${styles.errorHeading}`}>
                {assistanceError ? <FormattedMessage id="error.message.aiassitance" /> : <FormattedMessage id="error.message.system" />}
                </span>
            </div>
            <div className={classNames(styles.errorMessage, {
                [styles.TokenLimit]: assistanceError,
                [styles.errorBac]: !assistanceError,
            })}>
              <div className ={classNames("font-inter",styles.errorMessageText, {
                [styles.assistanceText]: assistanceError,
                [styles.errorMsgText]: !assistanceError,
              })}>
              {assistanceError ? (<FormattedMessage id="error.message.aiassitancemsg" />) : (message?.err_message)}
              </div>
            </div>
            {!assistanceError && (
            <div className="flex gap-3 items-center">
            <div className={styles.errorBtn}  onClick={() => {
                onRegenerate &&
                onRegenerate(messageIndex ? messageIndex : 0, {} as IChatModel )
            }}>
              <div className="flex gap-[2px] sm:gap-[5px]">
               <span className="mt-[2px]"> <TryAgainIcon /> </span> 
               <span className={`font-inter ${styles.ErrorbtnText}`}> 
               {assistanceError ? <FormattedMessage id="workspace.create.continue" /> : <FormattedMessage id="error.message.try.again" /> }</span> 
              </div>
            </div>
            <div className={styles.RportBugBtn} onClick={handleReportBug}>
              <div className="flex gap-[2px] sm:gap-[5px]">
               <span className="mt-[2px]"> <ReportBug /> </span> 
               <span className={`font-inter ${styles.btnText}`}> 
               {assistanceError ? <FormattedMessage id= "error.message.shortenresponse"/> : <FormattedMessage id="error.message.report.bug" /> }</span> 
              </div>
            </div>
            </div>
            )}
          </div>
    );
}